import { Flex, Text } from 'components'
import { useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router'
import { RoutePath } from '../utils/routing'

export default function WorkspacePage() {
  const navigate = useNavigate()
  const { workspaceId } = useParams()

  useEffect(() => {
    goToEventsPage()
  })

  function goToEventsPage() {
    navigate(generatePath(RoutePath.Events, { workspaceId: workspaceId! }))
  }

  return (
    <Flex>
      <Text>Workspace page coming soon</Text>
    </Flex>
  )
}
